import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface DocsLayoutProps {
  children: React.ReactNode
  /** Stretch content to the full container width instead of the default
   *  reading-width column. Opt-in so existing docs pages are unaffected. */
  fullWidth?: boolean
}

export function DocsLayout({ children, fullWidth = false }: DocsLayoutProps) {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1))
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
      return () => clearTimeout(timeoutId)
    }
    const scrollContainer = document.querySelector('[data-docs-scroll]')
    if (scrollContainer) scrollContainer.scrollTop = 0
  }, [location.hash])

  return (
    <div className="h-full w-full overflow-y-auto bg-background" data-docs-scroll>
      <div className={`mx-auto px-4 py-6 md:px-6 ${fullWidth ? 'max-w-none' : 'max-w-4xl'}`}>
        {children}
      </div>
    </div>
  )
}
